/* @jsx jsx */
import React from 'react';
import clientConfig from '@root/client-config';
import BasePortableText from '@sanity/block-content-to-react';
import serializers from '@utils/serializers';
import {css, jsx} from '@emotion/react';
import {colors, fonts, unitConverter} from '@utils/base'

const portableTextCss = css`
  font-family: ${fonts.signo};

  p, h1, h2, h3, h4, blockquote, figure, ul, ol {
    margin-bottom: ${unitConverter('10px')};
    color: ${colors.secondaryText};
  }

  p, h1, h2, h3, h4, blockquote {
    opacity: .75;
  }

  h1, h2, h3, h4 {
    font-family: ${fonts.tektonPro};
  }

  ul, ol {
    list-style-position: inside;
  }

  a {
    text-decoration: none;
    border-bottom: ${unitConverter('1px')} dotted ${colors.text};
    color: ${colors.link};

    &:hover {
      color: ${colors.linkHover};
    }
  }

  figure {
    border: ${unitConverter('1px')} solid #999;
    padding: ${unitConverter('10px')};

    .gatsby-image-wrapper {
      margin-bottom: ${unitConverter('10px')};
    }

    figcaption {
      text-align: center;
    }
  }
`;

const PortableText = ({blocks, className}) => (
  <BasePortableText
    blocks={blocks}
    serializers={serializers}
    css={portableTextCss}
    className={className}
    {...clientConfig.sanity}
  />
);

export default PortableText;
